var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app","lang":_vm.lang}},[(_vm.theme)?_c('div',{staticClass:"bng-pageloader",class:{'is-active':_vm.loading}},[_c('div',[_vm._v(_vm._s(_vm.client.view.general.alias))])]):_vm._e(),_vm._v(" "),(!_vm.loading)?_c('router-view'):_vm._e(),_vm._v(" "),_c('modal-mbk')],1)}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// c:/Jenkins/workspace/play-at-home-test-frontend-deploy-sites/src/onlinecasino/OnlineCasino.Web.Public/node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!c:/Jenkins/workspace/play-at-home-test-frontend-deploy-sites/src/onlinecasino/OnlineCasino.Web.Public/node_modules/vue-loader/lib??vue-loader-options!./skins/bulmasite/App.vue?vue&type=template&id=291c1dba
// module id = 7urb
// module chunks = 0